<template>
  <div>
    <!-- 背景图 -->
    <div class="top">
      <div class="t-t1">直播/微课</div>
      <div class="t-t2box">
        <div class="t-t2">惟理想点亮生命的精彩</div>
      </div>
    </div>

    <div class="box">
      <div class="title">
        <div class="t1">班组建设管理标准化及基层管理者能力提升</div>

        <div class="t2">
          <div class="t2-time">时间：2022-06-15</div>
          <div class="t2-text">来源 ：谛听咨询</div>
        </div>

        <div class="line"></div>
      </div>
      <!-- 一 -->
      <div class="item">
        <!-- 标题 -->
        <div class="biaotitle">
          <img src="@/image/zhibo/xiangqin/zhuangshi@2x (1).png" alt="" />
          <div class="bt">授课老师</div>
        </div>

        <!-- 名字 -->
        <div class="namebox">
          <div class="name">张三</div>

          <div class="js1">谛听咨询有限公司 项目总监</div>
          <div class="js1">精益生产高级咨询师</div>
        </div>

        <div class="textbox">
          <div class="t1">辅导企业建立全面的6S目视化管理体系，有效的提升企业的现场管理水平；推动企业全自动生产线TPM活动，调动全员参与，实现产品良品率提升</div>
          <div class="t1">15%， 设备稼动率提升20%， 同时所负责的良品率提升及稼动率提升项目获得市级“讲评比”优秀项目称号</div>
        </div>
      </div>

      <!-- 二 -->
      <div class="item">
        <!-- 标题 -->
        <div class="biaotitle">
          <img src="@/image/zhibo/xiangqin/zhuangshi@2x (1).png" alt="" />
          <div class="bt">课程收益</div>
        </div>

        <div class="textbox">
          <div class="t1">※明确现场管理者的管理职责与角色定位，树立正确的管理意识与心态观念</div>
          <div class="t1">※了解现场管理的整体框架，掌握现场日常管理的 重点方法</div>
          <div class="t1">※学习基层班组七大任务管理模型， 提高基层管理者管理技能，提升执行力</div>
        </div>
      </div>

      <!-- 三 -->
      <div class="item">
        <!-- 标题 -->
        <div class="biaotitle">
          <img src="@/image/zhibo/xiangqin/zhuangshi@2x (1).png" alt="" />
          <div class="bt">报名方式</div>
        </div>

        <div class="textbox">
          <div class="t1">1、扫描下方图片二维码，进入小程序</div>
          <div class="t1">2、点击进入该课程，点击立即报名</div>
          <div class="t1">3、选择校区为北京冠卓咨询有限公司，下单支付后即可收听课</div>
        </div>

        <div class="img">
          <div>
            <img src="@/image/zhibo/xiangqin/tu1@2x (2).png" alt="" />
          </div>
          <img src="@/image/zhibo/xiangqin/tu2@2x (3).png" alt="" />
        </div>

        <div class="textbox" style="color: #4581fb">
          <div class="t1">以最低的价格听最优质的课</div>
          <div class="t1">期待您的参与</div>
        </div>

        <div class="line2"></div>

        <!-- 上下页 -->
        <div class="change">
          <div class="chang1">
            上一页：
            <div class="c1">新工厂精益布局规划</div>
          </div>
          <div class="chang1">
            下一页：
            <div class="c1">新工厂精益布局规划</div>
          </div>
        </div>
        <!-- 上下页end----------- -->
      </div>
    </div>

    <!-- 推荐 -->
    <div class="tuij">
      <!-- 标题 -->
      <div class="tuij-text">为您推荐</div>
      <!-- 推荐列表 -->
      <div class="tuij-box">
        <!-- 推荐项 -->
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>

        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>

        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DczxxXiangqin',

  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="scss" scoped>
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/zhibo/bj.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}

.box {
  width: 100%;
  .title {
    margin: 50px auto;
    width: 1300px;
    text-align: center;
    position: relative;

    .t1 {
      font-size: 38px;
      letter-spacing: 4px;
      font-weight: 600;
    }
    .t2 {
      position: absolute;
      display: flex;
      right: -10px;
      top: 90px;
      color: #333333;
      font-size: 14px;

      .t2-text {
        margin-left: 30px;
      }
    }

    .line {
      height: 2px;
      width: 1360px;
      background-color: #fafafa;
      position: absolute;
      top: 130px;
    }
  }

  .item {
    width: 1200px;
    margin: 150px auto;
    position: relative;

    .biaotitle {
      width: 300px;
      margin: 20px auto 40px auto;
      position: relative;

      img {
        width: 100%;
        margin-left: -10px;
      }

      .bt {
        position: absolute;
        top: -7px;
        left: 90px;
        font-size: 25px;
        font-weight: 600;
      }
    }

    .namebox {
      border: 1px solid #4581fb;
      width: 320px;
      height: 180px;
      margin: 0 auto;
      border-radius: 4px;
      margin-bottom: 40px;
      .name {
        font-size: 30px;
        width: 60px;
        margin: 30px auto 20px auto;
      }
      .js1 {
        width: 220px;
        margin: 0 auto;
        margin-bottom: 8px;

        text-align: center;
      }
    }

    .textbox {
      .t1 {
        width: 1220px;
        margin: 0 auto;
        margin-bottom: 8px;
        letter-spacing: 1px;

        text-align: center;
      }
    }

    .img {
      width: 370px;
      margin: 30px auto;
      img {
        width: 380px;
      }
    }

    .line2 {
      height: 2px;
      width: 1360px;
      background-color: #fafafa;
      margin-top: 25px;
      margin-left: -30px;
    }
  }

  .change {
    position: absolute;
    bottom: -50px;

    left: 100px;

    display: flex;
    width: 1000px;

    justify-content: space-between;

    .chang1 {
      display: flex;
      font-size: 15px;
    }
    .c1:hover {
      color: #4581fb;
    }
  }
}

.tuij {
  height: 450px;
  background-color: #f7f8fb;
  overflow: hidden;

  .tuij-text {
    width: 200px;
    text-align: center;
    margin: 50px auto;
    font-size: 25px;
  }

  .tuij-box {
    width: 1000px;
    height: 300px;

    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .dian {
      margin-top: 6px;
      margin-right: 5px;
      background-color: #4581fb;
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }

    .tuij-item {
      width: 450px;

      display: flex;

      .left {
        display: flex;

        .tuij-name {
          font-size: 15px;
        }
      }

      .tuij-time {
        margin-left: 100px;
        font-size: 13px;
        color: #999999;
      }
    }
  }
}
</style>
